import { Outlet, Link } from "react-router-dom";

import './Layout.css';
import { UserBadge } from "./elements/UserBadge";
import abuss from './res/abuss.png';

const DriverLayout = () => {

  return (
    <div className="column" style={{ width: '100%', minHeight: '100vh', height: 'auto', paddingBottom: '128px' }}>
      <div className="row center-cross g16" style={{ paddingBlock: '16px', paddingInline: '48px' }}>
        <Link to="/platform" className="default">
          <img src={abuss} style={{ height: "48px" }} />
        </Link>

        <div style={{ flex: 1 }}></div>

        <UserBadge/>
      </div>

        <nav className="row" style={{ width: '100%' }}>
            <div style={{ width: '32px' }}></div>
            <Link className="nav-button" to="/platform">Töölaud</Link>
            <Link className="nav-button" to="/platform/schedule">Kalender</Link>
            <div style={{ marginRight: '32px', flex: 1 }}></div>
        </nav>

      <Outlet />
    </div>
  )
};

export default DriverLayout;